﻿//To clean up the Errors on click of close button
$('#modalLogin button[data-dismiss=modal]').click(function () {
    $("#errorDiv").empty();
});

$("#modal_login_form").submit(function (e) {
    e.preventDefault();
    //$("#btn-login").click(function () {
    var ob = {};
    ob.ModalEmail = $("#ModalEmail").val();
    ob.ModalPassword = $("#ModalPassword").val();
    $("#errorDiv").empty();
    $("#modal_login_spinner").show();
    //var funcUrl = $(this).attr("data-urlaction");
    //alert(funcUrl);
    $.ajax({
        type: 'POST',
        url: '/My/Account/ModalLogin',
        contentType: 'application/json; charset=utf-8',
        dataType: "json",
        data: JSON.stringify(ob),
        async: true,
        beforeSend: function (xhr) {
        },
        success: function (response) {
            $("#modal_login_spinner").hide();
            if (response.success == true) {
                window.location.reload();
            }
            else {
                $("#errorDiv").empty();
                $.each(response.errors, function (index, value) {
                    $("#errorDiv").append("<p>" + value + "</p>");
                });
                $("#errorDiv").removeClass("displayNone");
            }
        },
        failure: function (response) {
        }
    });
});